<template>
	<el-form v-loading="isScheduleAsyncOperationPending">
		<table class="employee-schedule-table">
			<tbody>
				<tr>
					<th style="width: 120px;">месяц</th>
					<th style="width: calc(100% / 31);" v-for="(_, i) in new Array(31)" :key="i">
						{{ i + 1 }}
					</th>
				</tr>

				<tr v-for="(m, mI) in months" :key="mI">
					<td>{{ m }}</td>
					<td
						v-for="(_, dI) in employeeSchedule[mI]" :key="dI"
						:class="{'toggled': !!_?.id, 'disabled': !isWorkingDayDisabled(mI, dI)}"
						@click="() => onToggleScheduleDateClick(mI, dI)"
						@click.right = "(e) => onScheduleDateRightClick(mI, dI, e)">
					</td>
				</tr>
			</tbody>
		</table>
	</el-form>

	<el-dialog
		v-model="isScheduleEditDialogVisible"
		width="500">
			<div style="display: flex;">
				<div style="flex-grow:3">
					<el-time-select
						v-model="scheduledDate!.scheduledStartTime"
						:max-time="scheduledDate!.scheduledEndTime"
						placeholder="Начало смены"
						:start="sheduledDayMinStartTime"
						step="00:15"
						:end="sheduledDayMaxEndTime"
					/>
				</div>
				<div style="flex-grow:1">
					-
				</div>
				<div style="flex-grow:3">
					<el-time-select
						v-model="scheduledDate!.scheduledEndTime"
						:min-time="scheduledDate!.scheduledStartTime"
						placeholder="Завершение смены"
						:start="sheduledDayMinStartTime"
						step="00:15"
						:end="sheduledDayMaxEndTime"
					/>
				</div>
			</div>
			&nbsp;
			<el-input
				v-model="scheduledDate!.notes"
				:autosize="{ minRows: 3, maxRows: 6 }"
				type="textarea"
				maxlength="5000"
				show-word-limit
				placeholder="Комментарии, видны только менеджерам"
			/>
			<template #footer>
				<div style="text-align: left;">
					<el-button type="primary" @click="onExistingScheduledDayUpdateClick">
						Сохранить
					</el-button>
					<el-button @click="isScheduleEditDialogVisible = false">
						Отмена
					</el-button>
				</div>
			</template>
	</el-dialog>

	<el-dropdown ref="dropdown1" trigger="contextmenu">
		<span extId="ddl2"></span>
		<template #dropdown>
			<el-dropdown-menu ref="dd1">
				<el-dropdown-item v-if="!!scheduledDate?.id" @click="onDropDownMenuChangeItemClick">Изменить смену</el-dropdown-item>
				<el-dropdown-item v-else @click="onDropDownMenuAddItemClick">Добавить смену</el-dropdown-item>
				<el-dropdown-item :disabled="true">Назначить по шаблону</el-dropdown-item>
				<el-dropdown-item @click="onDropDownMenuDeleteItemClick">Удалить смену</el-dropdown-item>
			</el-dropdown-menu>
		</template>
	</el-dropdown>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { ElButton, ElNotification, ElTimeSelect } from 'element-plus';
import EmployeeModel from '@/models/EmployeeModel';
import EmployeeScheduledDateModel from '@/models/EmployeeScheduledDateModel';
import EmployeesSchedulesApiClient from '@/helpers/api/EmployeesSchedulesApiClient';
import store from '@/store';

@Options({
	props: {
		employeeId: {
			type: Number,
			require: true
		}
	},
	components: {
		ElTimeSelect, ElButton
	}
})
export default class EmployeeScheduleComponent extends Vue {
	/** props */
	employeeId!: number;

	/** constants */
	sheduledDayMinStartTime = '09:00:00';
	sheduledDayMaxEndTime = '21:00:00';
	months = [
		'январь', 'февраль', 'март', 'апрель', 'май', 'июнь', 'июль', 'август', 'сентябрь', 'октябрь', 'ноябрь', 'декабрь'
	];

	/** view-models */
	isScheduleDropdownVisible = false;
	isScheduleAsyncOperationPending = false;
	isScheduleEditDialogVisible = false;
	employeesSchedulesApiClient = new EmployeesSchedulesApiClient(store.getters.jwt);
	/** referenced by form of creating|updating existing scheduled work date */
	scheduledDate: EmployeeScheduledDateModel | null = null;
	employeeScheduleYear: number = new Date().getFullYear();
	employeeSchedule: Array<Array<EmployeeScheduledDateModel>> = [
		new Array(31), new Array(31), new Array(31),
		new Array(31), new Array(31), new Array(31),
		new Array(31), new Array(31), new Array(31),
		new Array(31), new Array(31), new Array(31)
	];

	mounted() {
		this.isScheduleAsyncOperationPending = true;
		Promise.all([
			this.fetchScheduleAsync()
		]).then(() => this.isScheduleAsyncOperationPending = false);

		window.dispatchEvent(new Event('resize'));
	}

	async fetchScheduleAsync() {
		try {
			this.isScheduleAsyncOperationPending = true;
			const schedule = await this.employeesSchedulesApiClient.getScheduleAsync(this.employeeScheduleYear, this.employeeId);

			if (!schedule) {
				throw new Error('Wrong response received');
			}

			this.cleanEmployeeSchedule();
			schedule.forEach(_ => {
				const scheduledDateModel = new EmployeeScheduledDateModel(_);
				const scheduledDate = scheduledDateModel.scheduledDate;
				this.employeeSchedule[scheduledDate.getMonth()][scheduledDate.getDate()-1] = scheduledDateModel;
			});
		}
		catch(e: any) {
			ElNotification({
				message: 'Не удалось загрузить график работы',
				type: 'error',
			});
			console.error(`Unable to load employee's #${this.employeeId} schedule`, e);
		} finally {
			this.isScheduleAsyncOperationPending = false;
		}
	}

	isWorkingDayDisabled(zeroBasedMonth: number, zeroBasedDay: number) {
		return new Date(this.employeeScheduleYear, zeroBasedMonth + 1, 0).getDate() > zeroBasedDay;
	}

	onToggleScheduleDateClick(zeroBasedMonth: number, zeroBasedDay: number) {
		if (!this.isWorkingDayDisabled(zeroBasedMonth, zeroBasedDay)) {
			return;
		}

		const existingScheduledDate = this.employeeSchedule[zeroBasedMonth][zeroBasedDay];

		if (existingScheduledDate?.id) {					
			this.isScheduleAsyncOperationPending = true;	
			this.employeesSchedulesApiClient
				.deleteScheduleAsync(existingScheduledDate.id)
				.then(isDeleted => {
					if (isDeleted) {
						this.fetchScheduleAsync();
					} else {
						this.isScheduleAsyncOperationPending = false;
					}
				});
		} else {
			this.isScheduleAsyncOperationPending = true;
			const scheduledDate = new EmployeeScheduledDateModel({
				scheduledDate: new Date(this.employeeScheduleYear, zeroBasedMonth, zeroBasedDay+1),
				scheduledStartTime: this.sheduledDayMinStartTime,
				scheduledEndTime:  this.sheduledDayMaxEndTime,
				employee: new EmployeeModel({id: this.employeeId})
			});
			this.employeesSchedulesApiClient
				.addScheduleAsync(scheduledDate)
				.then(isAdded => {
					if (isAdded) {
						this.fetchScheduleAsync();
					} else {
						this.isScheduleAsyncOperationPending = false;
					}
				});
		}		
	}

	onScheduleDateRightClick(zeroBasedMonth: number, zeroBasedDay: number, e: Event) {	
		e.stopPropagation();
		e.preventDefault();
		const dropDownDefaultShowHideTimeoutMs = 150;
		const dropDownComponent = this.$refs.dropdown1 as any;		
		const dropDownMenu = (this.$refs.dd1 as any).$el.parentNode?.parentNode?.parentNode?.parentNode as HTMLElement;
		const isValidElHidden = dropDownMenu.offsetParent === null;
	
		const existingScheduledDate = this.employeeSchedule[zeroBasedMonth][zeroBasedDay];
		if (existingScheduledDate?.id) {
			this.scheduledDate = new EmployeeScheduledDateModel(existingScheduledDate);
		} else {
			this.scheduledDate = new EmployeeScheduledDateModel();
			this.scheduledDate.employee = new EmployeeModel({ id: this.employeeId });
			this.scheduledDate.scheduledDate = new Date(this.employeeScheduleYear, zeroBasedMonth, zeroBasedDay+1);
			this.scheduledDate.scheduledStartTime = this.sheduledDayMinStartTime;
			this.scheduledDate.scheduledEndTime = this.sheduledDayMaxEndTime;
		}
		
		const showDropdownMenuHandler = () => {
			const dropdownLinkElem = document.querySelector("[extId=ddl2]") as HTMLElement;
			const eventTargetElem = e.target as HTMLElement;
			eventTargetElem.appendChild(dropdownLinkElem);				
			dropDownComponent.handleOpen();
		};

		if (!isValidElHidden) {
			dropDownComponent.handleClose();			
			window.setTimeout(showDropdownMenuHandler, dropDownDefaultShowHideTimeoutMs);
		} else {
			showDropdownMenuHandler();
		}
	}

	onDropDownMenuChangeItemClick() {		
		this.isScheduleEditDialogVisible = true;
	}

	onDropDownMenuAddItemClick() {
		this.isScheduleAsyncOperationPending = true;
		this.employeesSchedulesApiClient
			.addScheduleAsync(this.scheduledDate!)
			.then(isAdded => {
				if (isAdded) {
					this.fetchScheduleAsync();
				} else {
					this.isScheduleAsyncOperationPending = false;
				}
			});
	}

	onDropDownMenuDeleteItemClick() {
		const existingScheduledDateId = this.scheduledDate!.id;
		this.isScheduleAsyncOperationPending = true;
		this.employeesSchedulesApiClient
				.deleteScheduleAsync(existingScheduledDateId)
				.then(isDeleted => {
					if (isDeleted) {
						this.fetchScheduleAsync();
					} else {
						this.isScheduleAsyncOperationPending = false;
					}
				});
	}

	onExistingScheduledDayUpdateClick() {
		if (this.isScheduleAsyncOperationPending == true) {
			return;
		}

		this.isScheduleAsyncOperationPending = true;
		this.employeesSchedulesApiClient
			.updateScheduleAsync(this.scheduledDate!)
			.then(isUpdated => {
				if (isUpdated) {
					this.fetchScheduleAsync();
				} else {
					this.isScheduleAsyncOperationPending = false;
				}
			});
	}

	cleanEmployeeSchedule() {
		for (let i = 0; i < this.employeeSchedule.length; i++) {
			this.employeeSchedule[i] = new Array(31);
		}
	}
}
</script>

<style scoped>
.employee-schedule-table {
	width: 100%;
	border-spacing: 0;
	border-collapse: separate;
}

	.employee-schedule-table tr {
		background: #fff;
		transition: background ease-in-out .1s;
	}

		.employee-schedule-table tr:hover {
			background: var(--el-color-primary-light-9);
		}

	.employee-schedule-table th {
		font-weight: normal;
		font-size: 1.08rem;
		background: var(--el-disabled-bg-color);
		padding: .44rem 0;
		border-right: 1px solid var(--el-border-color);
	}

	.employee-schedule-table td {
		padding: .3rem 1.6rem;
		border-right: 1px solid var(--el-border-color);
		border-bottom: 1px solid var(--el-border-color);
		cursor: pointer;
	}

		.employee-schedule-table td:first-child {
			text-align: right;
		}

		.employee-schedule-table td.toggled {
			background: var(--el-color-success-light-8);
		}

		.employee-schedule-table td.disabled {
			cursor: default;
			background: var(--el-disabled-bg-color);
		}
</style>